<script setup lang="ts">
    import { onMounted, onUnmounted } from 'vue';
    import { useXRaysStore } from '@/views/dicoms/xrays/xraysViewStore';
    import { useRoute } from 'vue-router';
    import { caseIdFromRoute } from '@/router';
    import XRayViewport from '@/views/dicoms/xrays/XRayViewport.vue';
    import { XRAY_2D_3D_VIEW_IDS, type XRay2D3DViewId } from '@/api/xrays';

    const store = useXRaysStore();
    const route = useRoute();

    function overviewBorder(view: XRay2D3DViewId) {
        return view === store.mainViewId ? 'lg primary opacity-100' : 'lg opacity-0';
    }

    function viewTitle(view: XRay2D3DViewId) {
        switch (view) {
            case 'ap':
                return 'AP';
            case 'left-oblique':
                return 'Left (Oblique)';
            case 'right-oblique':
                return 'Right (Oblique)';
            default:
                throw new Error(`Unknown xray view-id: ${view}`);
        }
    }

    onMounted(() => {
        store.loadCase(caseIdFromRoute(route));
    });

    onUnmounted(() => {
        store.stop();
    });
</script>

<template>
    <div class="d-flex flex-column" style="background: black; min-width: 400px">
        <div class="d-flex flex-row flex-grow-1">
            <x-ray-viewport
                viewport-id="main"
                :title="viewTitle(store.mainViewId)"
                class="flex-grow-1"
            />
            <div class="pa-2 ga-2 d-flex flex-column">
                <v-btn
                    v-for="id in XRAY_2D_3D_VIEW_IDS"
                    :key="id"
                    variant="text"
                    color="primary"
                    height="auto"
                    rounded="md"
                    class="pa-0"
                    :border="overviewBorder(id)"
                    @click="store.mainViewId = id"
                >
                    <x-ray-viewport
                        class="overview-viewport"
                        :viewport-id="`${id}-overview`"
                        :title="viewTitle(id)"
                    />
                </v-btn>
            </div>
        </div>
        <div class="d-flex flex-row justify-center align-baseline ga-4">
            <v-btn
                size="md"
                color="primary"
                variant="outlined"
                rounded
                :text="`Reset View`"
                class="py-2 px-4 ma-2 text-none"
                @click="store.resetMainView()"
            />
            <v-slider
                v-model="store.mainViewZoom"
                label="Zoom"
                color="primary"
                class="text-white px-4"
                thumb-size="12px"
                track-color="white"
                track-size="2px"
                min="-4"
                max="0"
                style="max-width: 320px"
                hide-details
            >
            </v-slider>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .overview-viewport {
        width: 200px;
        height: 200px;
    }


    :deep(.v-slider) {
        .v-slider-track__background {
            opacity: 0.8;
        }

        .v-slider__label {
            opacity: 0.9;
        }
    }
</style>
